import * as z from "zod/v4";

export const getBaseSupportPredictedPriceInfo = {
  name: "getBaseSupportPredictedPriceInfo" as const,
  input: z.null(),
  output: z.object({
    pricingTiers: z.array(
      z.object({ numTickets: z.number(), priceInCents: z.number() }),
    ),
    currentBucketIndex: z.number(),
  }),
};
